export default "__VITE_ASSET__Dx$RSaz6__"